import { render } from "./CommonLeaveDates.vue?vue&type=template&id=e081836e&scoped=true"
import script from "./CommonLeaveDates.vue?vue&type=script&lang=js"
export * from "./CommonLeaveDates.vue?vue&type=script&lang=js"

import "./CommonLeaveDates.vue?vue&type=style&index=0&id=e081836e&scoped=true&lang=scss"

import exportComponent from "/app/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e081836e"]])

export default __exports__